import { ArrowRight, FileCheck, Flag, Link as LinkIcon, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';

const steps = [
  { icon: LinkIcon, title: 'Soumettez', text: 'Collez un lien, un email ou scannez un QR code reçu par message.' },
  { icon: ShieldCheck, title: 'Analysez', text: 'SENTINELLE vérifie les sources de menace et calcule un score clair.' },
  { icon: FileCheck, title: 'Documentez', text: 'Un rapport forensics peut être généré pour garder une preuve exploitable.' },
  { icon: Flag, title: 'Signalez', text: 'Transmettez le dossier à une autorité compétente en quelques gestes.' },
];

export default function HowItWorksPage() {
  return (
    <div className="page-container">
      <Header />
      <section className="mx-4 mt-6">
        <h1 className="text-2xl font-bold text-brand-navy">Comment ça marche ?</h1>
        <p className="mt-2 text-sm text-text-muted leading-relaxed">Un parcours simple pour vérifier, comprendre et agir sans vocabulaire technique.</p>
      </section>

      <div className="mx-4 mt-6 space-y-4">
        {steps.map(({ icon: Icon, title, text }, index) => (
          <div key={title} className="card flex gap-4 items-start">
            <span className="w-12 h-12 rounded-xl bg-brand-navy text-white flex items-center justify-center flex-shrink-0">
              <Icon className="w-6 h-6" />
            </span>
            <div>
              <p className="text-xs font-mono text-accent-blue">Étape {index + 1}</p>
              <h2 className="font-bold text-lg text-text-primary mt-1">{title}</h2>
              <p className="text-sm text-text-muted leading-relaxed mt-1">{text}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mx-4 mt-6 card bg-brand-navy text-white">
        <h2 className="font-bold text-lg">Pensé pour le téléphone</h2>
        <p className="mt-2 text-sm text-white/70 leading-relaxed">Les boutons sont grands, les verdicts sont lisibles, et chaque action importante reste accessible au pouce.</p>
        <Link to="/analyze" className="mt-4 btn-primary bg-white text-brand-navy">
          Lancer une vérification <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    </div>
  );
}
